import { Component, ContentChild, EventEmitter, Input, Output, OnDestroy, Renderer2, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GridComponent } from '@progress/kendo-angular-grid';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'grid-context-menu',
    template: /*html*/ `
        @if (show$ | async) {
          <kendo-popup [offset]="offset$ | async">
            <ul class="menu">
              @for (item of contextMenuItems; track item) {
                <li (click)="menuItemSelected(item)">
                  @if (menuItemTemplate) {
                    <ng-template [ngTemplateOutlet]="menuItemTemplate"
                      [ngTemplateOutletContext]="{ item: item, dataItem: dataItem }">
                    </ng-template>
                  }
                  @if (!menuItemTemplate && item.text && item.url) {
                    <a href="{{ item.url }}" target="_blank">
                      {{item.text}}&nbsp;
                      @if (item.text == 'Edit') {
                        <fa-icon icon="external-link-alt" title="link to Flow Maker portal"></fa-icon>
                      }
                    </a>
                  }
                  @if (!menuItemTemplate && item.text && item.items) {
                    <kendo-menu [items]="item.items" [vertical]="true" style="display:inline-block;" [hoverDelay]="400">
                      <ng-template kendoMenuItemTemplate let-item="item" let-index="index">
                        @if (!item.url) {
                          <div style="color:#656565; width: 50px; margin: -6px;">{{item.text}}</div>
                        }
                        @if (item.url) {
                          <a href="{{ item.url }}" target="_blank">
                            {{item.text}}&nbsp;
                            <fa-icon icon="external-link-alt" title="link to Flow Maker portal"></fa-icon>
                          </a>
                        }
                      </ng-template>
                    </kendo-menu>
                  }
                  @if (!menuItemTemplate && !item.url && !item.items) {
                    {{ item }}
                    @if (item == 'Snapshots' || item == 'Versioning' || item == 'Restore' || item == 'Save As' || item == 'Save Copy' || item == 'Diff' || item == 'Edit JSON' || item == 'Rename Actions' || item == 'Get More Runs (slow)' || item == 'Export Excel' || item == 'Flow Diagram' ) {
                      <i class="ms-Icon ms-Icon--Diamond" aria-hidden="true" title="subscription feature"></i>
                    }
                    @if (item == 'Owners' || item == 'Solution Aware' || item == 'Run Now' || item == 'Edit in Designer') {
                      <i class="ms-Icon ms-Icon--TestBeakerSolid" aria-hidden="true" title="experimental feature"></i>
                    }
                  }
                </li>
              }
            </ul>
          </kendo-popup>
        }
        `,
    styles: [/*css*/ `
     .menu {
        list-style:none;
        margin: 0;
        padding: 0;
        cursor: pointer;
      }

      .menu li {
        border-bottom: 1px solid rgba(0,0,0,.08);
        padding: 8px 12px;
        transition: background .2s, color .2s;
      }

      .menu li:last-child {
        border-bottom: 0;
      }

      .menu li:hover {
        background: #e8e8e8;
      }

      .menu li:active {
        background: #ff6358;
        color: #fff;
      }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GridContextMenuComponent implements OnDestroy {

    @ContentChild(TemplateRef, {static: true})
    public menuItemTemplate: TemplateRef<any>;

    @Input()
    public menuItems: any[] = [];
    public contextMenuItems: any[] = [];

    @Input() public admin: boolean = false;

    @Input() public filter: (items: any[]) => any[] = items => items;

    @Output()
    public select: EventEmitter<any> = new EventEmitter<any>();

    @Input() public set for(grid: GridComponent) {
        this.unsubscribe();
        this.cellClickSubscription = grid.cellClick.subscribe(this.onCellClick);
    }

    public show$ = new BehaviorSubject(false);
    public dataItem: any;
    public offset$ = new BehaviorSubject({left:0, top:0});

    private cellClickSubscription: Subscription;
    private documentClickSubscription: any;

    constructor(private renderer: Renderer2) {
        this.onCellClick = this.onCellClick.bind(this);
        this.documentClickSubscription = this.renderer.listen('document', 'click', () => {
            this.show$.next(false);
        });
    }

    public ngOnDestroy(): void {
        this.unsubscribe();
        this.documentClickSubscription();
    }

    public menuItemSelected(item: any): void {
        this.select.emit({ item: item, dataItem: this.dataItem });
    }

    private onCellClick({ dataItem, type, originalEvent }): void {
      if (type === 'contextmenu') {
        originalEvent.preventDefault();
        this.dataItem = dataItem;

        if (this.admin && this.dataItem.adminActions) {
            this.contextMenuItems = this.filter(this.dataItem.adminActions);
        }
        else if (this.dataItem.actions) {
            this.contextMenuItems = this.filter(this.dataItem.actions);
        }
        else {
            this.contextMenuItems = this.filter(this.menuItems);
        }

        this.show$.next(true);
        this.offset$.next({ left: originalEvent.pageX, top: originalEvent.pageY });
      }
    }

    private unsubscribe(): void {
        if (this.cellClickSubscription) {
            this.cellClickSubscription.unsubscribe();
            this.cellClickSubscription = null;
        }
    }

}
